import Immutable from 'immutable';
import * as ACTIONS from '../../actionTypes/cruiseListActionTypes';

const initialState = null;

export default (state = initialState, action) => {
  switch (action.type) {
    case ACTIONS.ADD_MESSAGE: {
      if (action.message) {
        return Immutable.fromJS(action.message);
      }
      return state;
    }
    default:
      return state;
  }
};